/**
 * An empty `texts.title` served the literal "undefined" in the title and description, live on
 * `nicequest.worldcoo.com/aviso-legal`; without a portal name the page uses its own and drops the description.
 */
export function legalPageSeo(props: {
	/** e.g. `t\`Legal Notice\``. */
	pageName: string;
	portalTitle: string | undefined;
	/** Only called with a portal title that exists. */
	describe: (portalTitle: string) => string;
}): { title: string; description: string | undefined } {
	if (!props.portalTitle) return { title: props.pageName, description: undefined };
	return {
		title: `${props.pageName} – ${props.portalTitle}`,
		description: props.describe(props.portalTitle),
	};
}
